module.exports = __webpack_public_path__ + "assets/img/logitech-astrogaming-w720.8b010480.webp";